"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.667 13.877l1.133 1.608H7.2l1.133-1.608v-3.024a3.684 3.684 0 012.724-3.563v-.342c0-.523.423-.948.943-.948s.943.425.943.948v.34a3.686 3.686 0 012.724 3.565v3.024zM13.519 16.473c0 .844-.681 1.527-1.519 1.527a1.524 1.524 0 01-1.518-1.527h3.037z" }), "Notification");
//# sourceMappingURL=Notification.js.map